import { render, staticRenderFns } from "./how-to-play.vue?vue&type=template&id=5a250555&scoped=true&"
import script from "./how-to-play.vue?vue&type=script&lang=js&"
export * from "./how-to-play.vue?vue&type=script&lang=js&"
import style0 from "./how-to-play.vue?vue&type=style&index=0&id=5a250555&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a250555",
  null
  
)

export default component.exports